import { Menu } from '@typings';

import { MenuItem } from '../MenuItem';

interface Props {
  items: Menu.Item[];
  title: string;
}

export const MenuSection = ({ items, title }: Props) => {
  return (
    <nav>
      <h2 className="mb-1 text-neutral-60 heading-4">{title}</h2>
      <ul className="mx-2 flex flex-col gap-1">
        {items.map(
          ({ isHidden, id, link, isExternal, name, onClick }) =>
            !isHidden && <MenuItem key={link} link={link} name={name} id={id} isExternal={isExternal} onClick={onClick} />,
        )}
      </ul>
    </nav>
  );
};
